import { useFeatureServices } from "../use-feature-services";
import {BreadcrumbServiceV1} from '@volkswagen-onehub/breadcrumb-service';
import { useRoute } from "./use-route";
import { useBreadcrumbs } from './use-breadcrumbs';
import { useEffect } from "react";

const useRootHistory = () => {
    const breadcrumbService = useFeatureServices()['breadcrumb-service'] as BreadcrumbServiceV1;
    const {rootHistory} = useFeatureServices()['s2:history'];

    const route = useRoute();

    useBreadcrumbs(breadcrumbService, rootHistory, route);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
};

export default useRootHistory;
